// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionToken } from "../config/userPool";

const {
  REWARD_INVENTORY_LISTING_ENDPOINT,
  CAMPAIGN_LISTING_ENDPOINT,
  CAMPAIGN_ENDPOINT,
  CAMPAIGN_DETAILS_ENDPOINT,
  CAMPAIGN_DELETE_ENDPOINT,
  CAMPAIGN_UPDATE_STATUS_ENDPOINT,
  CAMPAIGN_CONFIG_ENDPOINT,
  CAMPAIGN_APPROVERS_LIST_ENDPOINT,
  CAMPAIGN_TEMPLATE_DOWNLOAD_ENDPOINT,
  CAMPAIGN_INTERCHANGE_LIST_ENDPOINT,
  AUDIT_ENDPOINT,

} = config.api_endpoint;

const initialState = {
  loading: false,
  campaign_list: [],
  error: null,
  next_key: {},
  detail_loading: false,
  detail_data: {},
  export_list: [],
  detail_error: null,
  config_list: [],
  config_loading: false,
  audit_data: [],
  audit_loading: false,
  audit_error: null,
  reward_inventory_list: [],
  redemption_list: [],
  redemption_export_list: [],
  reward_inventory_detail_data: {},
  interchange_list: [],
  interchange_list_loading: false,
  approver_list: [],
  approver_list_loading: false,
  template_download: null,
  template_download_loading: false,

  campaign_matrix_list: [],
  definition_list: [],

};


export const fetchRewards = createAsyncThunk(
  "campaign/fetchRewards",
  async ({ campaign_type }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${REWARD_INVENTORY_LISTING_ENDPOINT}`;

      // Append status as a query parameter if provided
      if (campaign_type) {
        url += `?campaign_type=${campaign_type}`;
      }
      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchRedemptionList = createAsyncThunk(
  "campaign/fetchRedemptionList",
  async ({ params, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      const query = new URLSearchParams(params).toString();

      const results = await api.get(
        `${REWARD_INVENTORY_LISTING_ENDPOINT}/${id}/redemptions?${query}`,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchRewardRedemptionList = createAsyncThunk(
  "campaign/fetchRewardRedemptionList",
  async ({ id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();


      const results = await api.get(
        `${REWARD_INVENTORY_LISTING_ENDPOINT}/${id}/redemptions`,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchRewardRedemptionExportList = createAsyncThunk(
  "campaign/fetchRewardRedemptionExportList",
  async ({ id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      const results = await api.get(
        `${REWARD_INVENTORY_LISTING_ENDPOINT}/${id}/export`,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchDefinitionList = createAsyncThunk(
  "campaign/fetchDefinitionList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      const results = await api.get(
        `${REWARD_INVENTORY_LISTING_ENDPOINT}/definitions`,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const createAndUpdateDefinition = createAsyncThunk(
  "campaign/createAndUpdateDefinition",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      if (id) {
        const results = await api.put(
          `${REWARD_INVENTORY_LISTING_ENDPOINT}/definitions/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${REWARD_INVENTORY_LISTING_ENDPOINT}/definitions`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchRewardDefinitionDetail = createAsyncThunk(
  "campaign/fetchRewardDefinitionDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        REWARD_INVENTORY_LISTING_ENDPOINT + "/definitions/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const updateRewardDefinitionStatus = createAsyncThunk(
  "campaign/updateRewardDefinitionStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${REWARD_INVENTORY_LISTING_ENDPOINT}/definitions/${id}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;



    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const deleteRewardDefinitionById = createAsyncThunk(
  "campaign/deleteRewardDefinitionById",
  async ( id , { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
        REWARD_INVENTORY_LISTING_ENDPOINT + "/definitions/" + id,
        "",
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchCampaignMatrixList = createAsyncThunk(
  "campaign/fetchCampaignMatrixList",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();


      const results = await api.get(
        `${CAMPAIGN_ENDPOINT}/${id}/matrix`,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const createCampaignMatrix = createAsyncThunk(
  "campaign/createCampaignMatrix",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${CAMPAIGN_ENDPOINT}/${id}/matrix`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const updateCampaignMatrix = createAsyncThunk(
  "campaign/updateCampaignMatrix",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${CAMPAIGN_ENDPOINT}/${id}/matrix/${data.module_code}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const deleteCampaignMatrixByModule = createAsyncThunk(
  "campaign/deleteCampaignById",
  async ({ module_code, id }, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
        `${CAMPAIGN_ENDPOINT}/${id}/matrix/${module_code}`,
        '',
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchRedemptionExportList = createAsyncThunk(
  "campaign/fetchRedemptionExportList",
  async ({ params, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      const query = new URLSearchParams(params).toString();
      const results = await api.get(
        `${REWARD_INVENTORY_LISTING_ENDPOINT}/${id}/export?${query}`,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchRewardInventoryDetail = createAsyncThunk(
  "campaign/fetchRewardInventoryDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        REWARD_INVENTORY_LISTING_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchCampaigns = createAsyncThunk(
  "campaign/fetchCampaigns",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_LISTING_ENDPOINT}`;

      const results = await api.get(url, { ...data }, token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchCampaignConfig = createAsyncThunk(
  "campaign/fetchCampaignConfig",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_CONFIG_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchCampaignApprovers = createAsyncThunk(
  "campaign/fetchCampaignApprovers",
  async (approverType, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_APPROVERS_LIST_ENDPOINT}?approver_type=${approverType}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchTemplateDownloadURL = createAsyncThunk(
  "campaign/fetchTemplateDownloadURL",
  async (type, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_TEMPLATE_DOWNLOAD_ENDPOINT}/${encodeURI(type)}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchCampaignInterchange = createAsyncThunk(
  "campaign/fetchCampaignInterchange",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_INTERCHANGE_LIST_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchCampaignDetail = createAsyncThunk(
  "campaign/fetchCampaignDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        CAMPAIGN_DETAILS_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const createAndUpdateCampaign = createAsyncThunk(
  "campaign/createAndUpdateCampaign",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      if (id) {
        const results = await api.put(
          `${CAMPAIGN_ENDPOINT}/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${CAMPAIGN_ENDPOINT}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchPreviewNominees = createAsyncThunk(
  "campaign/fetchPreviewNominees",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${CAMPAIGN_ENDPOINT}/${id}/nominees/preview`,
        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchNominees = createAsyncThunk(
  "campaign/fetchNominees",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        `${CAMPAIGN_ENDPOINT}/${id}/nominees`,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const saveNominees = createAsyncThunk(
  "campaign/saveNominees",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${CAMPAIGN_ENDPOINT}/${id}/nominees`,
        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const approveNominees = createAsyncThunk(
  "campaign/approveNominees",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${CAMPAIGN_ENDPOINT}/${id}/nominees/approve`,
        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const generateReward = createAsyncThunk(
  "campaign/generateReward",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${CAMPAIGN_ENDPOINT}/${id}/generate_reward`,
        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const updateCampaignStatus = createAsyncThunk(
  "campaign/updateCampaignStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${CAMPAIGN_UPDATE_STATUS_ENDPOINT}/${id}/change_status`,

        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const deleteCampaignById = createAsyncThunk(
  "campaign/deleteCampaignById",
  async ({ data, id }, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
        CAMPAIGN_DELETE_ENDPOINT + "/" + id,
        JSON.stringify({ data }),
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);





export const fetchCampaignAudit = createAsyncThunk(
  "campaign/fetchCampaignAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${AUDIT_ENDPOINT}?table_name=gamifications-campaign&source_id=${id}`;
      const results = await api.get(url, {}, token);
      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

const campaignSlice = createSlice({
  name: "campaign",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchCampaignDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.detail_data = action.payload;
      })
      .addCase(fetchCampaignDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchCampaigns.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        state.loading = false;
        state.campaign_list = action.payload;
      })
      .addCase(fetchCampaigns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCampaignConfig.pending, (state) => {
        state.config_loading = true;
        state.config_list = [];
      })
      .addCase(fetchCampaignConfig.fulfilled, (state, action) => {
        state.config_loading = false;
        state.config_list = action.payload.data;
      })
      .addCase(fetchCampaignConfig.rejected, (state, action) => {
        state.config_loading = false;
        state.config_list = [];
        state.detail_error = action.error.message;
      })

      .addCase(fetchCampaignAudit.pending, (state) => {
        state.audit_loading = true;
      })
      .addCase(fetchCampaignAudit.fulfilled, (state, action) => {
        state.audit_loading = false;
        state.audit_data = action.payload;
      })
      .addCase(fetchCampaignAudit.rejected, (state, action) => {
        state.audit_loading = false;
        state.audit_error = action.error.message;
      })
      .addCase(updateCampaignStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCampaignStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCampaignStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRewards.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRewards.fulfilled, (state, action) => {
        state.loading = false;
        state.reward_inventory_list = action.payload;
      })
      .addCase(fetchRewards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchDefinitionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDefinitionList.fulfilled, (state, action) => {
        state.loading = false;
        state.definition_list = action.payload;
      })
      .addCase(fetchDefinitionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRedemptionList.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchRedemptionList.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.redemption_list = action.payload.data.redemptions;
      })
      .addCase(fetchRedemptionList.rejected, (state, action) => {
        state.detail_loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRewardRedemptionList.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchRewardRedemptionList.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.redemption_list = action.payload.data.redemptions;
      })
      .addCase(fetchRewardRedemptionList.rejected, (state, action) => {
        state.detail_loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRedemptionExportList.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchRedemptionExportList.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.redemption_export_list = action.payload.data;
      })
      .addCase(fetchRedemptionExportList.rejected, (state, action) => {
        state.detail_loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRewardInventoryDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchRewardInventoryDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.reward_inventory_detail_data = action.payload;
      })
      .addCase(fetchRewardInventoryDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchCampaignApprovers.fulfilled, (state, action) => {
        state.approver_list_loading = false;
        state.approver_list = action.payload.data;
      })
      .addCase(fetchCampaignApprovers.rejected, (state, action) => {
        state.approver_list_loading = false;
        state.approver_list = [];
      })
      .addCase(fetchCampaignInterchange.fulfilled, (state, action) => {
        state.interchange_list_loading = false;
        state.interchange_list = action.payload.data;
      })
      .addCase(fetchCampaignInterchange.rejected, (state, action) => {
        state.interchange_list_loading = false;
        state.interchange_list = [];
      })
      .addCase(fetchTemplateDownloadURL.pending, (state) => {
        state.template_download_loading = true;
      })
      .addCase(fetchTemplateDownloadURL.fulfilled, (state, action) => {
        state.template_download_loading = false;
        state.template_download = action.payload.data;
      })
      .addCase(fetchTemplateDownloadURL.rejected, (state, action) => {
        state.template_download_loading = false;
        state.template_download = null;
        state.error = action.error.message;
      })
  },
});

const CampaignReducer = campaignSlice.reducer;
export default CampaignReducer;
